import { MappedReturn } from 'store/returns/models/returnData';
import { DataLogStatus } from 'store/app/enums';

// Preference constants for review modal
export const REVIEW_MODAL_LATER_DATE = 'review-modal-later-date';
export const REVIEW_MODAL_NO_THANKS = 'review-modal-no-thanks';

/**
 * Check if user has at least one submitted return
 */
export const hasSubmittedReturn = (mappedReturns: MappedReturn[]): boolean => {
  if (!mappedReturns || mappedReturns.length === 0) {
    return false;
  }
  
  return mappedReturns.some(
    (returnItem) => returnItem.status === DataLogStatus.SUBMITTED
  );
};

/**
 * Check if review modal should be shown based on preferences
 */
export const shouldShowReviewModal = (
  reviewLaterDate: string | false | null | undefined,
  reviewNoThanks: boolean | false | null | undefined
): boolean => {
  // Don't show if user clicked "No Thanks"
  if (reviewNoThanks) {
    return false;
  }

  // If no "Later" preference, show modal
  if (!reviewLaterDate) {
    return true;
  }

  // Check if "Later" date has passed (show again the following day)
  try {
    const laterDate = new Date(reviewLaterDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Start of today
    
    const laterDateStartOfDay = new Date(laterDate);
    laterDateStartOfDay.setHours(0, 0, 0, 0);
    
    // Show if it's been at least one day since "Later" was clicked (laterDate is in the past)
    return laterDateStartOfDay < today;
  } catch (error) {
    // If date parsing fails, show modal
    return true;
  }
};

